<template>
	<div class="c-modal__mask c-modal__mask--grey c-gallery-images-modal" @click.self="hideModal">
		<div class="c-modal__wrapper c-gallery-images-modal__wrapper" :tabindex="1">
			<a class="c-modal__close c-modal__close--grey" @click="hideModal" @keydown.enter.prevent="hideModal"
			   :tabindex="1"></a>

			<div class="c-gallery-images-modal__container">
				<swiper
					:navigation="true"
					:loop="true"
					:modules="swiperModules"
					:initialSlide="getGalleryImagesModalActiveIndex"
					:speed="500"
					:keyboard="{
    					enabled: true,
  					}"
				>
					<swiper-slide v-for="(slide, index) in this.getGalleryImagesModalContent" :key="index">
						<div class="c-gallery-images-modal__slide">
							<img :src="slide.MediaUrl" alt="" v-if="slide.MediaType !== 'VideoExternal'" class="c-gallery-images-modal__slide__content c-carousel__item"/>
							<iframe v-else
									:id="'galleryVideoPlayer' + index"
									:src="slide.MediaUrl"
									:title="slide.MediaUrl"
									class="c-gallery-images-modal__slide__content"
									allow="autoplay; fullscreen"
									autoplay>
							</iframe>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import { Navigation, Keyboard } from "swiper";
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';

import 'swiper/scss';
import "swiper/scss/navigation";

export default {
	name: 'gallery-images-modal',
	components: {
		Swiper,
		SwiperSlide,
	},
	data() {
		return {
			swiperModules: [Navigation, Keyboard],
		}
	},
	computed: {
		...mapGetters([
			'getGalleryImagesModalVisible',
			'getGalleryImagesModalContent',
			'getGalleryImagesModalActiveIndex'
		]),

		isMobile() {
			return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		}
	},
	methods: {

		...mapMutations([
			'setGalleryImagesModalVisible'
		]),

		hideModal() {
			const updateGalleryImageModalVisible = !this.getGalleryImagesModalVisible;

			this.setGalleryImagesModalVisible(updateGalleryImageModalVisible);
		},

		handlerZoomClick() {
			document.querySelectorAll('.c-carousel__item').forEach(item => {
				item.onclick = function () {
					item.classList.toggle('c-carousel__item--zoom-in');
				}
			});
		},
	},

	mounted() {
		if (this.isMobile) {
			this.handlerZoomClick();
		}

	},
}
</script>
